import moment from 'moment';
const rootItem = document.getElementById('MainContent_PerfumeImageASCX_myDesign');
let templateId = 14;
let token = '6f038457-2519-4b1e-939d-5b47be0cda7c';
let language = 'de';
let textonly='0';
if (rootItem) {
    templateId = rootItem.getAttribute('data-id') || templateId;
    token = rootItem.getAttribute('data-token') || token;
    language = rootItem.getAttribute('language') || language;
    textonly = rootItem.getAttribute('textonly') || language;
}
const headers = { token };



export const sendData = (textInfo, imageInfo, callback, errCallback) => {
    fetch(`https://app.startmanager.ro/api/altemplates`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
            text: textInfo,
            image: imageInfo,
            templateId,
            date: moment().format('DD/MM/YYYY HH:mm'),
        }),
    })
        .then(response => {
            if (response.ok && callback) {
                callback(response);
            } else if (errCallback) {
                errCallback(response);
            }
        })
        .catch(err => {
            if (errCallback) {
                errCallback(err);
            }
        });
};

export const getInitials = async function() {
    try {
        const data = await fetch(`https://app.startmanager.ro/api/altemplates?templateId=${templateId}`, {
            method: 'GET',
            headers,
        });
        const json = await data.json();
        return json;
    } catch (e) {
        throw e;
    }
};

export const toDataURL = url =>
    fetch(url)
        .then(response => response.blob())
        .then(
            blob =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                }),
        );

export function objectValues(obj) {
    const values = [];

    for (const val in obj) {
        values.push(obj[val]);
    }
    return values;
}

export function getLanguage() {
    return language;
}

export function setTextOnly() {
    return textonly;
}


// WEBPACK FOOTER //
// ./src/Utils.js